import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

import variables from './../../../values.scss'

const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: variables.tooltipBack,
    color: variables.tooltipText,
    opacity: 1,
    padding: '12px 10px',
    border: '0px solid transparent',
    borderRadius: "4px",
    fontSize: "0.65rem",
    fontWeight: "normal",
    fontFamily: variables.font1,
    "& > .MuiTooltip-arrow": {
      "&:before": {
        color: variables.tooltipBack,
      }
    }
  },
}))(Tooltip);

const TooltipWrapper = props => {
  const { title, position } = props

  return (
    <HtmlTooltip title={title} placement={position} arrow>
      {props.children}
    </HtmlTooltip>
  )
}

export default React.memo(TooltipWrapper)
